import React from 'react';
import { Search, Filter, Plus } from 'lucide-react';

/**
 * ActionBar Component
 * Contains search, filters, and add user functionality
 * @param {Function} onAddUser - Callback function when Add User button is clicked
 */
const ActionBar = ({ onAddUser }) => {
  return (
    <div className="flex mb-6 justify-end">
        <button
          onClick={onAddUser}
          className=" flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus className="h-4 w-4" />
          Add User
        </button>
    </div>
  );
};

export default ActionBar;